import React from "react";
import { Frame, Dot } from "./styles";

interface Props {
	length: number;
	active: number;
	updateFunc?: (index: number) => void;
	className?: string;
}
const Dots: React.FC<Props> = (props) => {
	const { length, active, className, updateFunc } = props;
	return (
		<Frame className={className}>
			{new Array(length).fill(null).map((_, index) => (
				<Dot
					isActive={active == index}
					onClick={() => updateFunc && updateFunc(index)}
					key={index}
				/>
			))}
		</Frame>
	);
};

export default Dots;
